import React from 'react';
import styles from './PlaceholderContainer.module.scss';

const PlaceholderContainer = ({ children }) => {
	return <div className={styles.container}>{children}</div>;
};

export default PlaceholderContainer;
